import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, RadioGroup, Autocomplete } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelAbastecimentoFinal() {
  const [open, setOpen] = useState(true);
  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsDriver = useMemo(
    () => [
      {
        id: 'nomemotorista',
        label: t('s.cadastro.motorista.nomemotorista'),
        filter: { type: 'text' },
      },
      {
        id: 'idmotorista',
        label: t('s.cadastro.motorista.idmotorista'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    const idPosto = valuePosto === 0 ? '' : valuePosto;

    return {
      ...params,
      idposto: idPosto,
      nomeposto: params.codigonomeposto,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.amaggi.abastecimentofinal')}
      relatorio="relamaggisabastecimentofinal"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Autocomplete
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        title={t('s.geral.postocomboio')}
        defaultValue=""
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value.idposto === null) {
            setValuePosto(0);
            setInputValuePosto('');
          } else {
            setValuePosto(value.idposto);
          }
        }}
      />

      <PesquisaTabela
        name="idveiculo"
        label={t('s.menu.cadastro.veiculo')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={cellsVehicle}
      />

      <PesquisaTabela
        name="idmotorista"
        label={t('s.menu.cadastro.motorista')}
        primary="idmotorista"
        secondary="nomemotorista"
        url="motoristas"
        header={cellsDriver}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelAbastecimentoFinal;
